<template>
  <div>
    <Title :pages="[{ icon: 'receipt', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <ModalInventoryOperation v-if="create_access" :inventory_operation="mainItem" :formBtn="formBtn" :dialog="dialog"
        @closeDialog="dialog = false" @reload="filter" @updateItem="(newItem) => {
            inventory_operation = newItem;
          }
          "  @updateDialog="updateDialog" :modal_title="modal_title"/>

      <v-btn color="primary" class="mb-5" dark @click="dialog = true">Crear Operacion de Inventario</v-btn>

      <v-card>
        <div class="row mb-5 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-menu ref="desde_selected" v-model="desde_selected_open" :close-on-content-click="false"
                    :close-on-click="false" :return-value.sync="desde_selected" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-menu ref="hasta_selected" v-model="hasta_selected_open" :close-on-content-click="false"
                    :close-on-click="false" :return-value.sync="hasta_selected" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox v-model="op_type_selected" autocomplete="off" data-vv-as="op_type_selected"
                    name="op_type_selected" item-text="name" item-value="id" :items="op_types"
                    label="Tipo de operacion" class="pt-0 mt-0" clearable :loading="loading_op_types"></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox v-model="document_type_selected" autocomplete="off" data-vv-as="document_type_selected"
                    name="document_type_selected" item-text="name" item-value="id" :items="document_types"
                    label="Tipo de documentos" class="pt-0 mt-0" clearable :loading="loading_document_types" :disabled="op_type_selected == null"></v-combobox>
                </div>

                <div class="col-md-12 pt-0" style="display: flex; justify-content: end;">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>

        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }" @pagination="updatePagination" :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.id }}</td>
              <td>{{ item.creation_date }}</td>
              <td>{{ item.creation_user.business_name }}</td>
              <td>
                <span class="status-badge" :class="'op-type-' + item.op_type.id">
                  {{ item.op_type.name }}
                </span>
              </td>
              <td>{{ item.document_type.name }}</td>
              <td>{{ item.external_reference }}</td>
              <td>{{ item.observation	 }}</td>

              <td class="text-center px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(item)"> remove_red_eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";

import { inventoryOperationService } from "@/libs/ws/inventoryOperationService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ModalInventoryOperation from "@/views/InventoryOperation/ModalInventoryOperation.vue";

export default {
  components: { Title, ModalInventoryOperation },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: inventoryOperationService,
      page_title: "Operaciones de inventario",
      modal_title: "Operacion de inventario",
      mainItem: {
        id: 0,
        op_type: null,
        document_type: null,
        warehouse: null,
        stock_type: null,
        observation: "",
        external_reference: "",
        items: [],
      },

      defaultItem: null,
      headers: [
        { text: "N° Operacion", align: "left", sortable: true, value: "creation_date" },
        { text: "Fecha", align: "left", sortable: true, value: "creation_date" },
        { text: "Usuario", align: "left", sortable: true, value: "creation_user.business_name" },
        { text: "Tipo de Operacion", align: "left", sortable: true, value: "op_type.name" },
        { text: "Tipo de Documento", align: "left", sortable: true, value: "document_type.name" },
        { text: "Referencia Externa", align: "left", sortable: true, value: "external_reference" },
        { text: "Observaciones", align: "left", sortable: true, value: "observations" },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      document_types: [],
      op_types: [],
      loading_op_types: false,
      loading_document_types: false,
      desde_selected_open: false,
      hasta_selected_open: false,
      document_type_selected: null,
      op_type_selected: null,
      state_selected: null,
      desde_selected:new Date().toISOString().slice(0, 10),
      hasta_selected:new Date().toISOString().slice(0, 10),
    };
  },
  watch: {
    op_type_selected(newValue) {
      if(newValue)
        this.getAllDocumentTypes();
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service, this.getFilterParams());
    this.getOpTypes();
    // this.getAllDocumentTypes();
  },
  methods: {
    getFilterParams() {
      const param = {
        from: this.desde_selected,
        to: this.hasta_selected,
        document_type: this.document_type_selected != null ? this.document_type_selected.id : null,
        op_type: this.op_type_selected != null ? this.op_type_selected.id : null,
      };
      return param;
    },
    getOpTypes() {
      this.loading_op_types = true;

      this.service
        .getOpTypes()
        .then((response) => {
          if (response.status) {
            this.op_types = response.result;
          }
        })
        .catch((e) => {
          console.log("error get op types", e);

        })
        .finally(() => {
          this.loading_op_types = false;
        })
    },
    getAllDocumentTypes() {
      this.loading_document_types = true;
      const params = {
        op_type: this.op_type_selected != null ? this.op_type_selected.id : null,
      }

      this.service
        .getAllDocumentTypes(params)
        .then((response) => {
          if (response.status) {
            this.document_types = response.result;
          }
        })
        .catch((e) => {
          console.log("error get op types", e);

        })
        .finally(() => {
          this.loading_document_types = false;
        })
    },

    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
  },
};
</script>
